import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleIcon, UserIcon, CalendarIcon } from '../constants.tsx';
import type { Post } from '../App.tsx';

const Blog: React.FC<{posts: Post[]}> = ({ posts }) => {
    const { t } = useTranslation();

    // Display latest 3 posts on the homepage
    const latestPosts = posts.slice(0, 3);

    return (
        <section className="py-20 lg:py-24">
            <div className="max-w-6xl mx-auto px-4 sm:px-8 xl:px-0">
                <div className="mb-16 text-center">
                     <span className="hero-subtitle-gradient relative mb-4 font-medium text-sm inline-flex items-center gap-2 py-2 px-4.5 rounded-full">
                        <TitleIcon />
                        <span className="hero-subtitle-text"> {t('blogSectionSubtitle')} </span>
                    </span>
                    <h2 className="text-white mb-4.5 text-2xl font-extrabold sm:text-4xl">
                        {t('blogSectionTitle')}
                    </h2>
                    <p className="max-w-3xl mx-auto font-medium">
                       {t('blogSectionDescription')}
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
                    {latestPosts.map((post) => (
                        <div key={post.id} className="group">
                            <div className="mb-6 overflow-hidden rounded-xl">
                                <a href={post.href || `#/blog/${post.id}`}>
                                    <img src={post.imageUrl} alt={post.title} className="w-full h-64 object-cover ease-in-out duration-500 scale-100 group-hover:scale-110" />
                                </a>
                            </div>

                            <div className="flex flex-wrap gap-2.5 items-center mb-4.5">
                                {post.tags.map((tag, i) => (
                                    <span key={i} className="font-medium text-xs hover:text-white cursor-pointer py-1 px-2.5 rounded-full bg-white/[0.07] border border-white/10 hover:border-white/25 ease-out duration-300">
                                        {tag}
                                    </span>
                                ))}
                            </div>

                            <h4 className="text-start">
                                <a href={post.href || `#/blog/${post.id}`} className="text-white font-semibold text-xl ease-in duration-300 hover:opacity-80 line-clamp-2">{post.title}</a>
                            </h4>
                            <p className="font-medium mt-4 text-start line-clamp-3">{post.excerpt}</p>

                            <div className="flex items-center gap-4.5 flex-wrap mt-6 text-sm text-white/60">
                                <div className="flex items-center gap-2 flex-wrap cursor-pointer ease-in duration-300 hover:text-white">
                                    <UserIcon />
                                    <span>{post.author}</span>
                                </div>
                                <div className="flex items-center gap-2 flex-wrap cursor-pointer ease-in duration-300 hover:text-white">
                                    <CalendarIcon />
                                    <span>{post.date}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="mt-12 text-center">
                    <a href="/news/" className="header-signup-btn text-sm font-medium inline-flex items-center gap-2 py-3 px-6">
                        {t('navNews', 'الأخبار')} ←
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Blog;
